const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');

class PayyoSimulatePaymentRequestRecord extends AbstractPayyoRequestRecord {
    /**
     * @param {string} paymentId
     * @param {{}} data
     */
    constructor(paymentId, data) {
        if (!paymentId || !paymentId.startsWith('py_')) {
            throw new Error('A valid paymentId is required');
        }

        super(
            'POST',
            'payments/' + paymentId + '/simulate',
        );

        this.data = data;
    }
}

module.exports = PayyoSimulatePaymentRequestRecord;
